import { render, staticRenderFns } from "./ConfigurazioneDeviceSimListComponent.vue?vue&type=template&id=b71aa1a0"
import script from "./ConfigurazioneDeviceSimListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneDeviceSimListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports